<template>
	<article class="block placeholder">
		<div class="block__content">
			<span class="block__name">
				<b-skeleton width="35%" height="20"></b-skeleton>
				<b-skeleton width="60%" height="10"></b-skeleton>
			</span>
			<span class="block__copy">
				<b-skeleton width="150" height="25"></b-skeleton>
			</span>
		</div>
	</article>
</template>

<script>
export default {
	name: 'Placeholder'
}
</script>
